import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import '../SignUp/SignUp.css';

const LogIn = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: false
    });
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.email || !formData.password) {
            alert('Please fill in all fields!');
            return;
        }

        // Here you would typically send the data to your backend
        console.log('Form submitted:', formData);
        alert('Signed in successfully!');
    };

    const handleGoogleSignIn = () => {
        // Handle Google sign in logic here
        console.log('Google sign in clicked');
    };

    return (
        <div className="common-container d-flex justify-content-center align-items-center p-3 overflow-hidden fw-regular">
            <div className="common-card overflow-hidden my-0 mx-auto d-flex flex-column">
                {/* Header */}
                <div className="common-header text-center position-relative">
                    <div className="logo mb-1 fw-bold">
                        <i className="fas fa-rocket" style={{ marginRight: '0.5rem' }}></i>
                        ProjectFlow
                    </div>
                    <div className="logo-subtitle fw-regular">Streamline Your Projects</div>
                </div>
                <div className="common-body d-flex flex-column">
                    <h1 className="common-title fw-bold mb-3 text-center">Welcome Back</h1>
                    <button className="btn-google" onClick={handleGoogleSignIn}>
                        <i className="fab fa-google"></i>
                        Sign In with Google
                    </button>
                    <div className="divider text-center my-3 position-relative z-0">
                        <span className='bg-white px-3 fw-medium'>OR</span>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3 mb-4">
                            <Col xs={12}>
                                <Form.Group controlId="email">
                                    <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Enter your email address"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group controlId="password">
                                        <Form.Label>Password</Form.Label>
                                        <div className="password-field d-flex position-relative">
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                placeholder="Create password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                className="password-toggle ms-2 bg-transparent"
                                                onClick={togglePassword}
                                                aria-label="Toggle password visibility"
                                                tabIndex={-1}
                                            >
                                                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </Button>
                                        </div>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Link to="/forgot-password" className="btn btn-link text-decoration-none mb-2">Forgot Password?</Link>
                                <Form.Group controlId="rememberMe">
                                    <Form.Check
                                        type="checkbox"
                                        label="Remember me"
                                        name="rememberMe"
                                        checked={formData.rememberMe}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Button type="submit" className="btn-primary w-100">Sign In</Button>
                            </Col>
                        </Row>
                    </Form>
                    <div className="d-flex align-items-center justify-content-center">
                        Don't have an account? 
                        <Button variant="link" className="p-0 text-decoration-none ms-1" as={Link} to="/signup">
                            Sign Up
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogIn;
